const handleCloseFormParamFreq = {
  confirm: '¿Realmente quiere cancelar los cambios?',
  title: 'CAMBIOS NO GUARDADOS'
};

export default handleCloseFormParamFreq;
